import React from "react";
//#region types
import { CurrencyEnums } from "models/enums";
import { TitleWithAmountsProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const TitleWithAmounts: React.FC<TitleWithAmountsProps> = (props) => {
  const { title, amounts } = props;
  return (
    <Grid
      item
      container
      direction="row"
      spacing={3}
      alignItems="center"
      className={cssExports.dashboardMainChartTitleContainer}
    >
      <Grid item className={cssExports.title}>
        {title}
      </Grid>
      {amounts.map((a, index) => (
        <Grid key={index} item>
          <Grid item className={cssExports.labelTextLabel}>
            {DateHelper.formatMonthRange(a.dateRange.start, a.dateRange.end)}
          </Grid>
          <Grid item className={cssExports.labelTextContent}>
            {LocalizationHelperInstance.getFormattedCurrency(a.amount, CurrencyEnums.CurrencyCode.SEK)}
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default TitleWithAmounts;
